<template>
	<div class="container">
		<header class="header">
			<router-link :to="{ name: 'Home', params: { lang: $route.params.lang } }" class="title">
				<i class="fa fa-chevron-left" aria-hidden="true"></i>
				{{ $t('backBtn') }}
			</router-link>
			<div class="lang">
				<router-link class="lang__item" :class="{ active: $route.params.lang === 'uz' }"
					:to="{ name: 'Search', params: { lang: 'uz' } }">
					<img class="img" :src="linkImg + '/img/041-uzbekistan.png'" alt="" />
				</router-link>
				<router-link class="lang__item" :class="{ active: $route.params.lang === 'ru' }"
					:to="{ name: 'Search', params: { lang: 'ru' } }">
					<img class="img" :src="linkImg + '/img/044-russia.png'" alt="" />
				</router-link>
				<router-link class="lang__item" :class="{ active: $route.params.lang === 'en' }"
					:to="{ name: 'Search', params: { lang: 'en' } }">
					<img class="img" :src="linkImg + '/img/186-united-states.png'" alt="" />
				</router-link>
			</div>
		</header>
		<section class="section-search">
			<div class="search">
				<i class="fa fa-search" aria-hidden="true"></i>
				<input class="search__input" type="text" :placeholder="$t('search')" v-model="search" />
			</div>
			<div class="lists">
				<div v-for="item in filteredList" :key="item.BranchId" class="lists__item" @click="open(item.BranchId)">
					<h1 class="lists__title">{{ item.BranchName }}</h1>
					<span class="lists__subtitle">{{ item.BranchAddress }}</span>
				</div>
			</div>
		</section>
		<Loading v-show="loading" />
	</div>
</template>

<script>
// import Lang from '@/components/Lang.vue'
import Loading from "@/components/Loading.vue"
import axios from 'axios'

export default {
	data() {
		return {
			search: "",
			infos: [],
			loading: false,
			linkImg: '',
			deviceId: '',
			settings: '',
		}
	},
	components: {
		// Lang,
		Loading
	},
	beforeMount() {
		const deviceId = localStorage.getItem('deviceId')
		const deviceNumber = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)
		if (deviceId == null || deviceId == undefined) {
			localStorage.setItem('deviceId', deviceNumber)
		} else if (deviceId != '') {
			this.deviceId = deviceId
		} else {
			this.deviceId = deviceNumber
			localStorage.setItem('deviceId', deviceNumber)
		}

		this.linkImg = window.MY_CONFIG_EASYQ.linkImg
	},
	mounted() {
		this.loading = true
		this.settings = window.MY_CONFIG_EASYQ
		this.ListBranches()
		this.$i18n.locale = this.$route.params.lang
	},
	computed: {
		filteredList() {
			return this.infos.filter(post => {
				return post.BranchName.toLowerCase().includes(this.search.toLowerCase()) ||
					post.BranchAddress.toLowerCase().includes(this.search.toLowerCase())
			})
		}
	},
	methods: {
		open(id) {
			if (localStorage.name == 1) {
				this.$router.push({ name: 'Booking', params: { id: id } })
			}
			else {
				this.$router.push({ name: 'ETicket', params: { id: id } })
			}
		},
		async ListBranches() {
			const url = `${this.settings.apiBookingBarakaTexnika}/Branches/ListBranches`
			axios.get(url)
				.then(res => {
					this.infos = res.data
					this.loading = false
				})
				.catch((error) => console.log(error))
			// try {
			// 	this.infos = axios.get(this.settings.apiBookingBarakaTexnika + '/Branches/ListBranches');
			// 	// for (let index = 0; index < response.data.length; index++) {
			// 	// 	this.infos.push(response.data[index])
			// 	// }
			// } catch (error) {
			// 	console.error("Ошибка загрузки данных:", error)
			// } finally {
			// 	this.loading = false;
			// }
			// try {
			//   const [response2] = await Promise.all([
			//     axios.get(this.settings.apiBookingBarakaTexnika + '/Branches/ListBranches')
			//   ])
			//   for (let index = 0; index < response2.data.length; index++) {
			//     this.infos.push(response2.data[index])
			//   }
			//   this.loading = false
			// } catch (error) {
			//   console.error("Ошибка загрузки данных:", error)
			// }
		}
	},
	created() {
		this.$i18n.locale = this.$route.params.lang
	},
	watch: {
		'$route.params.lang'() {
			this.$i18n.locale = this.$route.params.lang
		}
	}
}
</script>
